import { CatTextLink } from '@blocks-react/components/TextLink';

interface DealerLocatorSearchResultMobileContactProps {
  children?: string;
}

export const DealerLocatorSearchResultMobileContact = ({
  children
}: DealerLocatorSearchResultMobileContactProps) => (
  <CatTextLink>{children}</CatTextLink>
);
